import React, { Component } from 'react';

import { VendorTable } from '../components/VendorTable';
import { VendorContacts } from '../components/VendorContacts';
import { VendorAddresses } from '../components/VendorAddresses';
import RoleUtils from '../utils/roleUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/Vendor.css';
import { Loading } from '../components/Loading';
export class VendorMaintenance extends Component {

    constructor(props) {
        super(props);  
        this.state = {
            hasAccess: false,
            isLoading: true,
            vendorData: {}
        };
    }
    componentDidMount() {
        const { currentCompanyId } = this.props;
        ServiceCalls.checkProfileAccess(currentCompanyId).then(function (data) {
            if (data) {
                this.setState({
                    hasAccess: data,
                    isLoading: true
                });
                ServiceCalls.getVendorInfo(Number(currentCompanyId)).then(function (results) {
                    if (results) {

                        this.setState({
                            hasAccess: data,
                            isLoading: false,
                            vendorData: results
                        });
                        
                    }
                    else {
                        this.setState({
                            hasAccess: data,
                            isLoading: false
                        });
                    }
                }.bind(this));
              
            }
            else {
                this.setState({ hasAccess: false, isLoading: false });
            }
        }.bind(this)); 
    }

    componentDidUpdate(prevProps, prevState) {
        const { currentCompanyId } = this.props;
        if (prevProps.currentCompanyId !== currentCompanyId) {
            this.setState({
                hasAccess: false,
                isLoading: true,
                vendorData: {}
            });
            ServiceCalls.checkProfileAccess(currentCompanyId).then(function (data) {
                if (data) { 
                    ServiceCalls.getVendorInfo(Number(currentCompanyId)).then(function (results) {
                        if (results) {
                            this.setState({
                                hasAccess: data,
                                isLoading: false,
                                vendorData: results
                            });
                        }
                        else {
                            this.setState({
                                hasAccess: data,
                                isLoading: false
                            });
                        }
                    }.bind(this));

                }
                else {
                    this.setState({ hasAccess: false, isLoading: false });
                }
            }.bind(this)); 
        }
    }
 
    render() {
        const { currentCompanyId,currentUser } = this.props;      
        const { isLoading, vendorData } = this.state;
        var hasProfileAccess =  RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.profileRoles());

        const contactsPanel = (hasProfileAccess)
            ? <VendorContacts currentCompanyId={currentCompanyId} currentUser={currentUser} vendorData={this.state.vendorData} /> 
            : <></>;
        const addressesPanel = (hasProfileAccess)
            ? <VendorAddresses currentCompanyId={currentCompanyId} currentUser={currentUser} vendorData={this.state.vendorData} /> 
            : <></>;

        const vendorForm = 
            (isLoading)
            ? <div style={{ margin: "auto", width: "250px" }}>
                <h3 className="primaryText">Supplier Profile</h3>
                <Loading />
            </div>
                : (this.state.hasAccess === true) ?
                    (vendorData.vendorId)
             ?
            <>
                <VendorTable currentCompanyId={currentCompanyId} currentUser={currentUser} vendorData={this.state.vendorData} showAll={true} title="Supplier Profile" returnUrl="" />  
                {contactsPanel} 
                {addressesPanel}        
              </>
            : <h3 style={{ marginTop: "10px" }}>Cannot find a Profile for this Supplier.</h3>
            : <h3 style={{ marginTop: "10px" }}>You do not have access rights to this page.</h3>;

        return (        
         <>
            {vendorForm}
         </>
        );
    }
}
